import React, { useMemo } from "react";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import DialogRoot from "@material-ui/core/Dialog";
import classNames from "classnames";

import { IconButtonBg } from "../../Buttons/IconButtonBg/IconButtonBg";
import "./Dialog.scss";

export const Dialog = ({
    classes,
    isOpen,
    onClose,
    hideTop,
    header,
    title,
    children,
    buttons,
    disabledActions,
    ...restProps
}) => {
    const handleClose = disabledActions ? e => e.preventDefault() : onClose;

    const dialogClasses = useMemo(()=>({
        root: classNames("dialog-root", classes?.root),
        paper: classNames("dialog-paper", classes?.paper)
    }),[ classes ]);

    return (
        <DialogRoot
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            classes={dialogClasses}
            {...restProps}
        >
            {
                !hideTop && (
                    <div className={"dialog-paper__header-wrapper"}>
                        <div className="dialog-paper__header">
                            <h2 className="dialog-paper__header-title">{title}</h2>

                            {
                                handleClose && (
                                    <IconButtonBg
                                        className={"dialog-paper__header-close"}
                                        onClick={handleClose}
                                    >
                                        <CloseIcon />
                                    </IconButtonBg>
                                )
                            }
                        </div>
                        <div>{header}</div>
                    </div>
                )
            }
            <div className={"dialog-title__children"}>
                {children}
            </div>
            {
                buttons && (
                    <div className={"dialog-paper__actions"}>
                        {buttons}
                    </div>
                )
            }
        </DialogRoot>
    );
};

Dialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    hideTop: PropTypes.bool,
    onClose: PropTypes.func,
    disabledActions: PropTypes.bool,
    header: PropTypes.node,
    children: PropTypes.node,
    onApply: PropTypes.func
};

Dialog.defaultProps = {
    disabledActions: false,
    hideTop: false,
    isOpen: false,
    title: "Dialog Title",
    children: "Dialog message"
};
